import axios from "axios";

const api = axios.create({
  baseURL: "https://marketingscapers.com/api", // replace with your base URL
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;